export const hasPermission = (permissions, key) =>
  Array.isArray(permissions) && permissions.includes(key);

export const hasAnyPermission = (permissions, keys) =>
  Array.isArray(permissions) && keys.some((key) => permissions.includes(key));
